import { SERVER_API_PATH } from "api/api-constants";
import { reportApiError, serverApi } from "api/api-server-actions";

export async function serverIngestTopic(sectionId: string, file: File): Promise<void> {
  try {
    const formData = new FormData();
    formData.append("section_id", sectionId);
    formData.append("file", file);
    await serverApi.post(`${SERVER_API_PATH}/ingestion/ingestions/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    reportApiError("serverIngestTopic", error);
    throw error;
  }
}
